'use client';

import { type HTMLAttributes, type PropsWithChildren } from 'react';
import { StyledBox } from './surface.styles';
import { SurfaceProps } from './types';

type SurfaceComponentProps = HTMLAttributes<HTMLDivElement> &
  SurfaceProps &
  PropsWithChildren;

export function Surface({
  backgroundColor = 'surface',
  borderRadius = 'medium',
  hasPadding = true,
  maxWidth,
  children,
  className,
  ...props
}: SurfaceComponentProps) {
  return (
    <StyledBox
      backgroundColor={backgroundColor}
      borderRadius={borderRadius}
      hasPadding={hasPadding}
      {...props}
      className={className}
    >
      {children}
    </StyledBox>
  );
}
